import React, { useEffect, useState } from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { Link } from 'react-router-dom';
import { StudyGuideMyGuideDataGrid } from './study-guide-my-guide-data-grid';
import { StudyGuideMyGuideModal } from './study-guide-my-guide-modal';
import { useClient } from 'jsonapi-react';
import { GuideAboutCard, GuideAboutCardBody, GuideAboutCardFooter, GuideAboutCardHeader, GuideAboutCardTitle } from '@/components/custom/guide';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { PlayfulCard } from '@/components/custom/playful-card';

export function StudyGuideMyGuide() {
  const [studyGuideData, setStudyGuideData] = useState([]);
  const playful = usePlayfulStudent();

  const client = useClient();

  const getStudyGuideData = async () => {
    const response = await client.fetch('study_plan_reports/study_guide_progress');
    return response.data;
  };

  useEffect(() => {
    getStudyGuideData().then(data => {
      if (data.study_guide_progress) setStudyGuideData(data.study_guide_progress);
    });
  }, []);

  const hasStudyGuideData = studyGuideData.length > 0;

  if (playful) {
    return (
      <PlayfulCard
        className="flex h-full flex-col gap-3 p-4"
        style={{ background: '#fff' }}
      >
        <p
          className="mb-0 text-sm font-extrabold"
          style={{ color: '#222731' }}
        >
          Guia de estudos
        </p>

        {!hasStudyGuideData && (
          <EmptyState
            type="data"
            title="Você ainda não iniciou o Guia"
            text={
              <span>
                Ir para o meu <Link to="/guia-de-estudos">Guia de Estudos</Link>
              </span>
            }
            variant="plain"
          />
        )}

        {hasStudyGuideData && (
          <>
            <StudyGuideMyGuideDataGrid data={studyGuideData.slice(0, 6)} />

            {studyGuideData.length > 6 && (
              <Dialog>
                <DialogTrigger asChild>
                  <button
                    type="button"
                    className="self-start text-sm font-bold"
                    style={{ color: 'var(--color-secondary)' }}
                  >
                    Ver mais
                  </button>
                </DialogTrigger>

                <StudyGuideMyGuideModal data={studyGuideData} />
              </Dialog>
            )}
          </>
        )}
      </PlayfulCard>
    );
  }

  return (
    <GuideAboutCard>
      <GuideAboutCardHeader>
        <GuideAboutCardTitle>Guia de estudos</GuideAboutCardTitle>
      </GuideAboutCardHeader>

      {!hasStudyGuideData && (
        <GuideAboutCardBody isEmpty>
          <EmptyState
            type="data"
            title="Você ainda não iniciou o Guia"
            text={
              <span>
                Ir para o meu <Link to="/guia-de-estudos">Guia de Estudos</Link>
              </span>
            }
            variant="plain"
          />
        </GuideAboutCardBody>
      )}

      {hasStudyGuideData && (
        <>
          <GuideAboutCardBody>
            <StudyGuideMyGuideDataGrid data={studyGuideData.slice(0, 6)} />
          </GuideAboutCardBody>

          {studyGuideData.length > 6 && (
            <GuideAboutCardFooter>
              <Dialog>
                <DialogTrigger asChild>
                  <Button variant="link">Ver mais</Button>
                </DialogTrigger>

                <StudyGuideMyGuideModal data={studyGuideData} />
              </Dialog>
            </GuideAboutCardFooter>
          )}
        </>
      )}
    </GuideAboutCard>
  );
}
